import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import $ from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';


const ExhibitionDrawer = ({ head, userId }) => {
  const history = useNavigate();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false)
  const [loginAccesslist, setLoginAccesslist] = useState([])

  //toggle model for logout.................................
  const toggleModal = () => {
    setIsOpen(!isOpen)
  }

  const loadScripts = () => {
    // This array contains all the files/CDNs 
    // const dynamicScripts = [
    //   'js/jquery.sticky.js',
    //   'js/metisMenu.min.js',
    //   'js/metisMenu-active.js',
    //   'js/main.js'
    // ];

    // for (let i = 0; i < dynamicScripts.length; i++) {
    //   const node = document.createElement('script');
    //   node.src = dynamicScripts[i];
    //   node.type = 'text/javascript';
    //   node.async = false;
    //   document.getElementsByTagName('head')[0].appendChild(node);
    // }
  }
  const logout = () => {
    sessionStorage.clear()
    navigate('/')
  }
  useEffect(() => {
    loadScripts();
    // console.log("233",JSON.parse(sessionStorage.getItem('LoginAccesslist'))[0]['IsRead'])
    // setLoginAccesslist(JSON.parse(sessionStorage.getItem('LoginAccesslist')))
  }, []);

  const onRedirect = (path) => {
    history.push({ pathname: path, state: { 'isSearchClear': true } });
  }

  return (
    <>
      <Modal isOpen={isOpen} onRequestClose={e => toggleModal()}>
        <div className="modal-dialog custom_modal_dialog" >
          <div className="modal-content confirm-logout
" style={{ borderRadius: '0px' }}>
            <div class="modal-header">
              <h5 class="modal-title modal_title_text">Confirm Logout</h5>
              {/* <button type="button" class="close modal-close" data-dismiss="modal" onClick={this.toggleModal}>&times;</button> */}
              <button type="button " class="close pop-close text-dark" data-dismiss="modal" onClick={e => toggleModal()} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>

            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="pop_label">Do you really want to logout?</h3>
                </div>
              </div>
            </div>

            <div class="row ">
              <div class="col-md-12">
                <div class="form-group text-right mod-fot">
                  <a class="btn save_btn del-pop-save" onClick={logout}> Yes</a>
                  <a class="btn cancel_btn del-pop-cancel" data-dismiss="modal"
                    style={{ marginLeft: '5px' }} onClick={toggleModal}> No</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </Modal>
      <div className="sticky">
        <div className="app-sidebar__overlay" data-bs-toggle="sidebar" />

        <div className="app-sidebar ps ps--active-y">
          <div className="side-header top-logo-almnt" style={{ width: '214px' }}>
            <a className="header-brand1" href="index.html">
              {/*  <img src="assets/images/brand/logo-white.png" class="header-brand-img desktop-logo" alt="logo">
                      <img src="assets/images/brand/icon-white.png" class="header-brand-img toggle-logo" alt="logo">*/}
              <img
                src="images/itme.png"
                className="header-brand-img light-logo"
                alt="logo"
                style={{ width: '40px' }}
              />
              <img
                src="images/itme.png"
                className="header-brand-img light-logo1"
                alt="logo"
                style={{ width: '40px' }}
              />
            </a>
            {/* LOGO */}
          </div>
          <div className="main-sidemenu">
            <div className="slide-left disabled d-none" id="slide-left">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width={24}
                height={24}
                viewBox="0 0 24 24"
              >
                <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
              </svg>
            </div>
            <ul className="side-menu top-space" style={{ marginRight: '0px' }}>
              <li className="slide">
                <Link to='/dashboard' >
                  <a
                    className="side-menu__item has-link"
                    data-bs-toggle="slide"
                  >
                    <span className="side-menu__label">
                      {" "}
                      <i className="fa fa-home" aria-hidden="true" /> Dashboard
                    </span>
                  </a>
                </Link>
              </li>
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide" >
                  <a style={{ marginLeft: '0px', paddingLeft: '0px' }}
                    className="nav-link side-menu__item"
                    data-bs-toggle="collapse"
                    href="#masters"
                    aria-expanded="false"
                    aria-controls="masters"
                  >
                    <span className="side-menu__label">
                      {" "}
                      <i className="fa fa-list-ul" aria-hidden="true" /> Accounts
                    </span>
                  </a>
                  <div className="collapse " id="masters">
                    <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                      <li className="slide">  <Link to='/receiptlist'>
                        <a className="side-menu__item"
                        >
                          <span className="side-menu__label">
                            {" "}
                            <i className="fa fa-list-ul" aria-hidden="true" /> Receipt
                          </span>
                        </a></Link>
                      </li>
                      <li className="slide">  <Link to='/proformalist'>
                        <a className="side-menu__item"
                        >
                          <span className="side-menu__label">
                            {" "}
                            <i className="fa fa-list-ul" aria-hidden="true" /> Proforma Invoice list
                          </span>
                        </a></Link>
                      </li>
                      <li className="slide">  <Link to='/reminderEmails'>
                        <a className="side-menu__item"
                        >
                          <span className="side-menu__label">
                            {" "}
                            <i className="fa fa-list-ul" aria-hidden="true" /> Reminder E-Mail
                          </span>
                        </a></Link>
                      </li>
                      <li className="slide">  <Link to='/ledgerList'>
                        <a className="side-menu__item"
                        >
                          <span className="side-menu__label">
                            {" "}
                            <i className="fa fa-list-ul" aria-hidden="true" /> Ledger
                          </span>
                        </a></Link>
                      </li>
                      <li className="slide">  <Link to='/taxinvoicelist'>
                        <a className="side-menu__item"
                        >
                          <span className="side-menu__label">
                            {" "}
                            <i className="fa fa-list-ul" aria-hidden="true" /> Tax Invoice List
                          </span>
                        </a></Link>
                      </li>
                      <li className="slide">  <Link to='/taxinvoiceexhibitors'>
                        <a className="side-menu__item"
                        >
                          <span className="side-menu__label">
                            {" "}
                            <i className="fa fa-list-ul" aria-hidden="true" /> Exhibitors
                          </span>
                        </a></Link>
                      </li>


                    </ul>
                  </div>
                </li>
              }
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to='/agentlist' >
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> Agent Entry
                      </span>
                    </a>
                  </Link>

                </li>
              }
              {/* <li className="slide">
                <Link to={'/features'}>
                  <a className="side-menu__item"
                  >
                    <span className="side-menu__label">

                      <i className="fa fa-list-ul" aria-hidden="true" /> Features
                    </span>
                  </a>
                </Link>
              </li> */}
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to={'/exhibitorlist'} >
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> Exhibitors
                      </span>
                    </a>
                  </Link>
                </li>
              }
              <li className="slide">
                <Link to={'/visitorslist'} >
                  <a className="side-menu__item"
                  >
                    <span className="side-menu__label">
                      {" "}
                      <i className="fa fa-list-ul" aria-hidden="true" /> Visitors
                    </span>
                  </a>
                </Link>
              </li>
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to={'/manualformsummary'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> Manual Forms Summary
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to={'/visainvitation'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> VA-Exhibitors
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to={'/visitorVisaInvitation'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> VA-Visitors
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to={'/addcircular'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> Circulars
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to={'/reportList'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> Reports
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {/*<li className="slide" >
                <a style={{marginLeft:'0px',paddingLeft:'0px'}}
                  className="nav-link side-menu__item"
                  data-bs-toggle="collapse"
                  href="#masters"
                  aria-expanded="false"
                  aria-controls="masters"
                >
                  <span className="side-menu__label">
                    {" "}
                    <i className="fa fa-list-ul" aria-hidden="true" /> Master
                  </span>
                </a>
                <div className="collapse " id="masters">
                  <ul className="flex-column sub-menu" style={{ marginRight: '0px' }}>
                    <li className="slide">  <Link to='/exhibitionMaster'>
                      <a className="side-menu__item"
                      >
                        <span className="side-menu__label">
                          {" "}
                          <i className="fa fa-list-ul" aria-hidden="true" /> Exhibition
                        </span>
                      </a></Link>
                    </li>
                    <li className="slide">  <Link to='/roleMasterList'>
                      <a className="side-menu__item"
                      >
                        <span className="side-menu__label">
                          {" "}
                          <i className="fa fa-list-ul" aria-hidden="true" /> Role
                        </span>
                      </a></Link>
                    </li>
                    <li className="slide">  <Link to='/chapterList'>
                      <a className="side-menu__item"
                      >
                        <span className="side-menu__label">
                          {" "}
                          <i className="fa fa-list-ul" aria-hidden="true" /> Chapters
                        </span>
                      </a></Link>
                    </li>
                  </ul>
                </div>
              </li> */}
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to={'/fasciaadmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> Fascia Approval
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to={'/exhibitorBadgesAdmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> Exhibitor Badges Approval
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {/* <li className="slide">
                <Link to={'/manageArea'}>
                  <a className="side-menu__item"
                  >
                    <span className="side-menu__label">
                      {" "}
                      <i className="fa fa-list-ul" aria-hidden="true" /> Manage Area
                    </span>
                  </a>
                </Link>
              </li> */}
              {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID != 5 &&
                <li className="slide">
                  <Link to={'/edirectoryAdmin'}>
                    <a className="side-menu__item"
                    >
                      <span className="side-menu__label">
                        {" "}
                        <i className="fa fa-list-ul" aria-hidden="true" /> E-Directory Approval
                      </span>
                    </a>
                  </Link>
                </li>
              }
              {/* <li className="slide">
                <Link to={'/powerreqadmin'}>
                  <a className="side-menu__item"
                  >
                    <span className="side-menu__label">
                      {" "}
                      <i className="fa fa-list-ul" aria-hidden="true" /> Power Connection Approval
                    </span>
                  </a>
                </Link>
              </li> */}

              {/* <li className="slide" style={{cursor:'pointer'}}   data-toggle="modal" data-target="#logout" onClick={toggleModal}>
                  <a className="side-menu__item"
                   >
                    <span className="side-menu__label">
                      {" "}
                      <i className="fa fa-list-ul" aria-hidden="true" /> Log Out

                      
                    </span>
                  </a>
              </li> */}

              {/*  <li class="slide">
                          <a class="side-menu__item has-link" data-bs-toggle="slide" href="#"><i class="side-menu__icon fe fe-activity "></i><span class="side-menu__label">Survey</span></a>
                      </li> */}
            </ul>
            <div className="slide-right" id="slide-right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width={24}
                height={24}
                viewBox="0 0 24 24"
              >
                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
              </svg>
            </div>
          </div>
          <div className="ps__rail-x" style={{ left: '0', bottom: '0' }}>
            <div className="ps__thumb-x" tabIndex={0} style={{ left: '0', width: '0' }} />
          </div>
          <div className="ps__rail-y" style={{ top: '0', right: '0', height: '625px' }}>
            <div
              className="ps__thumb-y"
              tabIndex={0}
              style={{ top: '0', height: '554px' }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default ExhibitionDrawer;